var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('ul',_vm._l((_vm.tabList),function(item,i){return _c('li',{key:i,class:{active: i===_vm.showType},on:{"click":function($event){_vm.changeType(i)}}},[_vm._v("\n          "+_vm._s(item)+"\n        ")])})),_vm._v(" "),_c('news-list',{attrs:{"tag":_vm.showType}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10971caa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 